import React, { useEffect, useState } from 'react'
import NavTabs from '~components/NavTabs'
import useFilterPesquisas from '../hooks/useFilterPesquisas';
import { useConfigureFooter } from '~hooks/useHelpers';
import CardItem from '../Components/Cards/CardItem';
import FilterList from '../Components/Filter/FilterList';
import { useParams } from 'react-router-dom';
import usePesquisasCampoClientes from '~fetchs/usePesquisasCampoClientes';
import ListSearchs from '../Components/Cards/ListSearchs';
import { prepareData } from '../helpers/searchHelpers';
import ModalResponse from '~components/Modal/ModalResponse';
import useModalAction from '~components/Modal/hooks/useModalAction';
import ClientHeader from '~components/ClientInfo/ClientHeader';
import useCliente from '~fetchs/useCliente';

const ViewFormHistory = () => {
  const { parameter: idCliente } = useParams();

  const { cliente } = useCliente(idCliente);
  
  const [filters, setFilters] = useState({ searchText: "", status: "Todos", title: 0, validityPeriod: "Todos" });
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(5);
  const [loading, setLoading] = useState(false);
  const [searchsData, setSearchsData] = useState([]);
  const [searchsTitle, setSearchsTitle] = useState([]);

  const [showMessageModal, setShowMessageModal] = useState({
    text: "",
    type: "success",
  });

  const { isModalOpenAction: isModalResponse, closeModalAction: closeModalResponse, openModalAction: openModalResponse } = useModalAction();

  const { pesquisasCampoCliente, pesquisasCampoClienteAll, carregando, titulos } = usePesquisasCampoClientes({ filters, clienteId: parseInt(idCliente), tipo: "historico" });

  useEffect(() => {
    const { dados  } = prepareData(pesquisasCampoCliente);
    setSearchsData(dados);
  }, [pesquisasCampoCliente]);

  useEffect(() => {
    if(titulos) {
      setSearchsTitle([
        {
          title: "Todas",
          id: 0
        },
        ...titulos
      ]);
    }
  }, [titulos])

  return (
    <>
      <ClientHeader dados={cliente} />

       <NavTabs
        navs={[
          { name: "Formulários Ativos", link: `/gestao-de-pesquisa/formularios/${idCliente}` },
          { name: "Histórico de Formulários", link: `/gestao-de-pesquisa/historico-formularios/${idCliente}` }
        ]}
      />
      <FilterList onFilterChange={setFilters} removeCliente={true} removeValidityPeriod={true} titulos={searchsTitle} />
      <ListSearchs setShowMessageModal={setShowMessageModal} pesquisas={((searchsData ?? []) || [])} pesquisasAll={pesquisasCampoClienteAll} skip={skip} take={take} setSkip={setSkip} carregando={carregando} setLoading={setLoading} loading={loading} tipo={"historico"} />

      {showMessageModal.text ? (
        <ModalResponse
          isOpen={true}
          closeModal={() => {
            const onClose = showMessageModal.onClose;
            setShowMessageModal((prev) => ({
              ...prev,
              text: "",
              onClose: () => {}
            }));

            closeModalResponse();

            if(onClose && typeof onClose == "function")
              onClose();
          }}
          status={showMessageModal.type ?? ""}
          message={showMessageModal.text ?? ""}
          submessage={showMessageModal.submessage ?? ""}
          button="Ok"
        />
      ) : null}
    </>
  )
}

export default ViewFormHistory